/**
 * @name Webgl.js
 */
import SetGui from "./libs/SetGui";
import SetStats from "./libs/SetStats";
import Mouse from "./modules/Mouse";

import Stage from "./Stage";
import Mesh from "./Mesh";

class Webgl {
    constructor(world, params) {
        this.world = world;
        this.params = params;

        this.flag = false;

        this.mouse = Mouse;

        this.stage = new Stage(this.world, this.params);
        this.mesh = new Mesh(this.stage, this.params);

        this.stats = new SetStats(this.world);
    }

    /**
     * @name __raf
     */
    __raf() {
        if (this.flag) {
            if (MODE) {
                this.stats.__raf();
            }
            this.mouse.__raf();
            this.mesh.__raf();
        }
    }

    /**
     * @name __resize
     */
    __resize(params) {
        if (this.flag) {
            this.params = params;
            this.stage.__resize(this.params);
            this.mesh.__resize();
        }
    }

    /**
     * @name __init
     */
    __init() {
        if (MODE) {
            console.log(`
                W   W  EEEEE  BBBB   GGGG  L
                W   W  E      B   B G      L
                W W W  EEEE   BBBB  G  GG  L
                WW WW  E      B   B G   G  L
                W   W  EEEEE  BBBB   GGGG  LLLLL
               `);
        }
        this.mouse.__init(this.world);
        this.flag = true;
    }
}

export default Webgl;